import ReCAPTCHA from "react-google-recaptcha";
import { useRef, useState, useEffect, forwardRef, useImperativeHandle } from "react";

type Props = {
    onVerify: (token: string | null) => void;
};

export type ReCaptchaWrapperRef = {
    reset: () => void;
};

const ReCaptchaWrapper = forwardRef<ReCaptchaWrapperRef, Props>(({ onVerify }, ref) => {
    const recaptchaRef = useRef<ReCAPTCHA>(null);
    const [token, setToken] = useState<string | null>(null);

    const handleChange = (value: string | null) => {
        setToken(value);
        onVerify(value);
    };

    useImperativeHandle(ref, () => ({
        reset: () => {
            recaptchaRef.current?.reset();
            setToken(null);
        }
    }));

    return (
        <div className="recaptcha-wrapper">
            <ReCAPTCHA
                ref={recaptchaRef}
                sitekey="6Le4SE4rAAAAALpo1Pj_pfM6Hnr4pj15pQ00YjHf"
                onChange={handleChange}
                className="recaptcha"
            />
        </div>
    );
});

export default ReCaptchaWrapper;
